import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ScrollToTop } from "../components";
import { connect } from "react-redux";
import DefaultLayout from "../layout/default";
import BlankLayout from "../layout/fullpage";

// Pages
import Home from "../pages/Dashboard/Home";

// Auth pages
import AuthRegister from "../pages/auths/AuthRegister";
import AuthLogin from "../pages/auths/AuthLogin";
import AuthReset from "../pages/auths/AuthReset";

// Error pages
import NotFound from "../pages/error/NotFound";
import PermissionDenied from "../pages/error/PermissionDenied";

// Driver pages
import DriverListPage from "../pages/Driver/DriverList";
import DriverAddPage from "../pages/Driver/DriverAdd";
import DriverEditPage from "../pages/Driver/DriverEdit";
import DriverDetailsPage from "../pages/Driver/DriverDetails";

// Employee pages
import EmployeeListPage from "../pages/Employee/EmployeeList";
import EmployeeAddPage from "../pages/Employee/EmployeeAdd";
import EmployeeEditPage from "../pages/Employee/EmployeeEdit";
import EmployeeDetailsPage from "../pages/Employee/EmployeeDetails";

// profile PAges
import ProfileSettingsPage from "../pages/Profile/ProfileSettings";

import EditFilePage from "../pages/File/EditFile";
import FileAction from "../pages/FileAction/FileAction";
import FileOverview from "../pages/FileOverview/FileOverview";

import BusList from "../pages/Bus/BusList";
import BusDetailsPage from "../pages/Bus/BusDetails"
import BusTripLogs from "../pages/Bus/BusTripLogs";
import BusReplacementLog from "../pages/Bus/BusReplacementLogs";
import StopList from "../pages/Stop/StopList";
import StopDetails from "../pages/Stop/StopDetails";
import ShiftList from "../pages/Shift/ShiftList";
import RouteList from "../pages/Route/RouteList";
import RouteAddPage from "../pages/Route/AddRoute";
import RouteDetailsPage from "../pages/Route/RouteDetails";
import StopSequenceManager from "../pages/Route/ManageRouteStop";
import PassListPage from "../pages/Pass/PassList";
import Report from '../pages/report'

//employee
import Booking from "../pages/employeehome/Booking";

import Loading from "../components/Loader/Loading";
import Authsetpwd from "../pages/auths/Authsetpwd";
import Passhistory from "../pages/employeehome/Passhistory";
import Viewpass from "../pages/employeehome/Viewpass";
import Boardingpass from "../pages/Driverhome.js/Boardingpass";
import Authverifyemail from "../pages/auths/Authverifyemail";
import Analytics from "../pages/analytics";
import Track from "../pages/Tracking";
import Busarrivalreport from "../pages/report/livereport/Busarrivalreport";
import Shiftdetails from "../pages/Shift/Shiftdetails";
import Stoprequest from "../pages/Stop/Stoprequest";
import Passchange from "../pages/employeehome/Passchange";
import RouteEdit from "../pages/Route/RouteEdit";
import Bustrip from "../pages/Bus/Bustrip";
import EmployeeTravelHistory from "../pages/Employee/EmployeeTravelHistory";
import DriverRidingHistory from "../pages/Driver/DriverRidingHistory";
import ListDetails from "../pages/AvailableBus/ListDetails";
import CurrentTrip from "../pages/Dashboard/admindashboard/CurrentTrip";
import BusActiveEmployee from "../pages/Bus/BusActiveEmployee";
import EmployeePassLog from "../pages/Employee/EmployeePassLog";
const FlashScreen = () => {
  return (
    <BlankLayout title="Loading..." mask="2" centered>
      <Loading />
    </BlankLayout>
  );
};

export const allRoutes = [
  // Public Routes
  {
    url: "/",
    element: <AuthLogin />,
    isProtected: false,
    routeTitle: "Login",
    accessRole: [],
  },
  {
    url: "/register",
    element: <AuthRegister />,
    isProtected: false,
    routeTitle: "Register",
    accessRole: [],
  },
  {
    url: "/forgot-password",
    element: <AuthReset />,
    isProtected: false,
    routeTitle: "Forgot Password",
    accessRole: [],
  },
  {
    url: "/reset-password",
    element: <Authsetpwd />,
    isProtected: false,
    routeTitle: "Reset Password",
    accessRole: [],
  },
  {
    url: "/verify-email",
    element: <Authverifyemail />,
    isProtected: false,
    routeTitle: "verify-email",
    accessRole: [],
  },
  // Protected Routes
    {
     url: "/current-trip",
    element:<CurrentTrip/>,
    isProtected: true,
    routeTitle: "Available Buses",
    accessRole: ["Admin", "Management"],
  },
  {
     url: "/available-bus",
    element:<ListDetails/>,
    isProtected: true,
    routeTitle: "Available Buses",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/dashboard",
    element: <Home />,
    isProtected: true,
    routeTitle: "Dashboard",
    accessRole: ["Admin", "Management", 'Employee', 'Driver'],
  },
  {
    url: "/analytics",
    element: <Analytics />,
    isProtected: true,
    routeTitle: "analytics",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/report",
    element: <Report />,
    isProtected: true,
    routeTitle: "reports",
    accessRole: ["Admin"],
  },
  {
    url: "/buses",
    element: <BusList />,
    isProtected: true,
    routeTitle: "Buses",
    accessRole: ["Admin", "Management"],
  }, {
    url: "/bus/:id",
    element: <BusDetailsPage />,
    isProtected: true,
    routeTitle: "Buse Details",
    accessRole: ["Admin", "Management"],
    children: [
      {
        url: "",
        element:<Bustrip/>,
        routeTitle: "Trips",
      },
      {
        url: "replacement-log",
        element: <BusReplacementLog />,
        routeTitle: "Repair Logs",
      },
       {
        url: "trip-log",
        element:<BusTripLogs/>,
        routeTitle: "Trip Logs",
      },
      {
        url: "active-employee",
        element:<BusActiveEmployee/>,
        routeTitle: "Active Employee",
      },
    ],
  },
  {
    url: "/stops",
    element: <StopList />,
    isProtected: true,
    routeTitle: "Stops",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/stopsrequests",
    element: <Stoprequest />,
    isProtected: true,
    routeTitle: "Stops requests",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/stop/:id",
    element: <StopDetails />,
    isProtected: true,
    routeTitle: "Stop Details",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/routes",
    element: <RouteList />,
    isProtected: true,
    routeTitle: "Routes",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/add-route",
    element: <RouteAddPage />,
    isProtected: true,
    routeTitle: "Add Route",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/tracking/:tab",
    element: <Track />,
    isProtected: true,
    routeTitle: "live tracking",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/route/:id",
    element: <RouteDetailsPage />,
    isProtected: true,
    routeTitle: "Route Details",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/route/:id/edit",
    element:<RouteEdit/>,
    isProtected: true,
    routeTitle: "Route Edit",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/route/:route_id/manage-stop",
    element: <StopSequenceManager />,
    isProtected: true,
    routeTitle: "Manage Route Stop",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/passes",
    element: <PassListPage />,
    isProtected: true,
    routeTitle: "Passes",
    accessRole: ["Admin", "Management"],
  }, {
    url: "/shifts",
    element: <ShiftList />,
    isProtected: true,
    routeTitle: "Shift",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/shift/:id",
    element: <Shiftdetails />,
    isProtected: true,
    routeTitle: "Shift",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/drivers/",
    element: <DriverListPage />,
    isProtected: true,
    routeTitle: "Drivers",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/add-driver/",
    element: <DriverAddPage />,
    isProtected: true,
    routeTitle: "Add Driver",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/driver/:id",
    element: <DriverDetailsPage />,
    isProtected: true,
    routeTitle: "Driver Details",
    accessRole: ["Admin", "Management"],
       children: [
      {
        url: "",
        element:<DriverRidingHistory/>,
        routeTitle: "tab1",
      },
    ],
  },
  {
    url: "/edit-driver/:id",
    element: <DriverEditPage />,
    isProtected: true,
    routeTitle: "Edit Driver",
    accessRole: ["Admin", "Management"],
  },

  {
    url: "/employees",
    element: <EmployeeListPage />,
    isProtected: true,
    routeTitle: "Employees",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/add-employee",
    element: <EmployeeAddPage />,
    isProtected: true,
    routeTitle: "Add Employee",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/edit-employee/:id",
    element: <EmployeeEditPage />,
    isProtected: true,
    routeTitle: "Edit Employee",
    accessRole: ["Admin", "Management"],
  },
  {
    url: "/employee/:id",
    element: <EmployeeDetailsPage />,
    isProtected: true,
    routeTitle: "Employee Details",
    accessRole: ["Admin", "Management"],
     children: [
      {
        url: "",
        element:<EmployeeTravelHistory/>,
        routeTitle: "Trips",
      },
      {
        url: "pass-log",
        element:<EmployeePassLog/>,
        routeTitle: "Employee pass Logs",
      },
    ],
  },
  {
    url: "/employee/booking",
    element: <Booking />,
    isProtected: true,
    routeTitle: "Employee Booking",
    accessRole: ["Employee"],
  },
  {
    url: "/employee/passchange",
    element: <Passchange />,
    isProtected: true,
    routeTitle: "Employee Booking",
    accessRole: ["Employee"],
  },
  {
    url: "/employee/passhistory",
    element: <Passhistory />,
    isProtected: true,
    routeTitle: "Pass history",
    accessRole: ["Employee"],
  },
  {
    url: "/employee/mypass",
    element: <Viewpass />,
    isProtected: true,
    routeTitle: "mypass",
    accessRole: ["Employee"],
  },
  {
    url: "/driver/boardingpass",
    element: <Boardingpass />,
    isProtected: true,
    routeTitle: "boardingpass",
    accessRole: ["Driver"],
  },

  // {
  //   url: "/profile",
  //   element: <ProfileSettingsPage />,
  //   isProtected: true,
  //   routeTitle: "Profile",
  //   accessRole: ["admin", "management", "user", "daak"]
  // },
  // {
  //   url: "/account-settings",
  //   element: <ProfileSettingsPage />,
  //   isProtected: true,
  //   routeTitle: "Account Settings",
  //   accessRole: ["admin", "management", "user", "daak"]
  // },
  // {
  //   url: "/file-action",
  //   element: <FileAction />,
  //   isProtected: true,
  //   routeTitle: "File Action",
  //   accessRole: ["management", "user"]
  // },{
  //   url: "/file-overview",
  //   element: <FileOverview />,
  //   isProtected: true,
  //   routeTitle: "File Overview",
  //   accessRole: ["admin"]
  // },
];


function Router({ isAuthenticated, userRole, isCheckingAuth }) {

  const handleProtectedRoute = (route) => {
    if (!isAuthenticated) {
      return <Navigate to="/" />;
    }
    if (!route.accessRole.includes(userRole)) {
      return <PermissionDenied />;
    }
    return route.element;
  };

  const handlePublicRoute = (route) => {
    if (isAuthenticated) {
      // Redirect authenticated users trying to access public routes
      return <Navigate to="/dashboard" />;
    }
    return route.element;
  };

  const renderRoutes = (routes, isChildElement = false) =>
    routes.map((item) => {
      let element;

      if (isChildElement) {
        element = item.element;
      } else {
        // Top-level route with layout
        element = item.isProtected ? (
          <DefaultLayout title={item.routeTitle}>
            {handleProtectedRoute(item)}
          </DefaultLayout>
        ) : (
          <BlankLayout title={item.routeTitle} centered>
            {handlePublicRoute(item)}
          </BlankLayout>
        );
      }

      return (
        <Route key={item.url} path={item.url} element={element}>
          {item.children &&
            renderRoutes(
              item.children.map((child) => ({
                ...child,
                isProtected: item.isProtected,
                accessRole: item.accessRole,
              })),
              true // pass Child Element flag
            )}
        </Route>
      );
    });

  return isCheckingAuth ? (
    <FlashScreen />
  ) : (
    <ScrollToTop>
      <Routes>
        {renderRoutes(allRoutes)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ScrollToTop>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "",
  isAuthenticated: state.auth.user !== null,
  isCheckingAuth: state.auth.isCheckingAuth,
});

export default connect(mapStateToProps)(Router);
